import { render } from "./Breadcrumb.vue?vue&type=template&id=77730df7"
const script = {}
script.render = render

export default script